import { Navigate, redirect, useNavigate } from "react-router";
import Toast from "../../Utils/Toast/toast-component";
import '../Login-Screen/Login.css';
import idanCover from '../../Assets/ai-gen-studio.png'
import youtubeLogo from '../../Assets/youtube.png'
import instagramLogo from '../../Assets/instagram.png'
import metaLogo from '../../Assets/meta.png'
import tiktokLogo from '../../Assets/tiktok.png'
import heartLogo from '../../Assets/heart.png'
import calendarLogo from '../../Assets/calendarLogo.png'
import * as authActions from '../../Redux/Auth/AuthActions'
import * as aiGenAction from '../../Redux/AiGen/AiGenActions'
import { post } from "../../Services/ApiService.js";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { LoadingAnimation } from "../../Utils/Progress/progress-component";
import { Modal } from "../../Utils/Modal/modal-component";
import Footer from "../../Utils/Footer/footer-component";
import Navbar from "../../Utils/Navbar/navbar-component.js";
import CourseCard from "../../Utils/Cards/course-card-component.js";
import VideoComponent from "../../Utils/Video/video-component.js";
import ReviewList from "../../Components/review-list-component.js";
import OverlappingCards from "../../Components/overlapping-course-component.js";
import courseData from "../../Public/course-data.js";
import ShortsList from "../../Components/shorts-list-component.js";
import VotingCard from "../../Utils/Cards/voting-card-component.js";

function Landing() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    let currentRoute = useSelector((state) => state.auth.currentRoute);
    const loading = useSelector((state) => state.loading);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [playlistVideos, setPlaylistVideos] = useState([]);
    // const tempPollData = useSelector((state) => state.aiGen.pollData);

    const [shorts, setShorts] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [expandCourse, setExpandCourse] = useState(false);
    const [expandVoter, setExpandVoter] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [points, setPoints] = useState(0);
    const stepperRef = useRef(null);


    const duration = 7000;
    const courseFormatters = courseData.getCourses();
    const targetPoints = parseInt(process.env.REACT_APP_TARGET_POINTS, 10);
    const baseEndpoint = `${process.env.REACT_APP_INFRA_ASSETS_ENDPOINT}/videos`;

    const links = [
        { logo: youtubeLogo, label: 'YouTube', url: 'https://www.youtube.com/@ai-gen-studio/shorts' },
        { logo: instagramLogo, label: 'Instagram', url: 'https://instagram.com/ai_gen_studio_s' },
        { logo: metaLogo, label: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61564293345136' },
        { logo: tiktokLogo, label: 'TikTok', url: 'https://www.tiktok.com/@aigenstudios' },
        { logo: heartLogo, label: 'Buy Me a Coffee', url: 'https://buymeacoffee.com/ai_gen_studio' },
        { logo: calendarLogo, label: 'Book Appointment', url: 'https://aigenstudio.zohobookings.com/#/aigenstudio' },
    ];


    const reviews = [
        {
            name: "Romi Omer",
            joinDate: "May 2021",
            reviewDate: "24/06/2021",
            reviewText: "Idan is truly amazing!",
            helpfulCount: "2",
            shortText: ""
        },
        {
            name: "Noga Diamond",
            joinDate: "May 2021",
            reviewDate: "24/06/2021",
            reviewText: "Bravo, Idan Kelman! What a marathon, what an effort. It's clear that you took our exam seriously. Your summaries are very detailed, and your assistance deserves a lot of appreciation. Please inform me of any marathon you lead :) Thank you very much.",
            helpfulCount: "4",
            shortText: ""
        },
        {
            name: "Ziv Partok",
            joinDate: "May 2021",
            reviewDate: "24/06/2021",
            reviewText: "Maybe slow down and write the pseudocode in a certain way, because the marathon instructor jumped quite quickly from topic to topic without fully finishing writing everything in an organized manner, and it was confusing.",
            helpfulCount: "4",
            shortText: ""
        },
        {
            name: "Sapir 😇",
            joinDate: "May 2021",
            reviewDate: "24/06/2021",
            reviewText: "It was professional and patient. In terms of comfort and aesthetics, maybe it's better if the Zoom background is clean and the lighting is clear on the face... or somehow the camera should be focused on the teacher's face and not from the side. He was caring, really listened to questions, and encouraged those who shared ideas. It really boosts confidence before the exam.",
            helpfulCount: "1",
            shortText: ""
        },
        {
            name: "Ram Be'er",
            joinDate: "July 2023",
            reviewDate: "03/07/2023",
            reviewText: "Thank you so much, Idan! It was really great.",
            helpfulCount: "1",
            shortText: ""
        }
    ];


    const adjustShortsForScreen = (videos) => {
        const isMobile = window.innerWidth <= 700;
        const minViews = 10000;
        let remainingViews = targetPoints - minViews * 8;
        let seed = 42;
        const seededRandom = () => (seed = (seed * 16807) % 2147483647) / 2147483647;

        return Array.from({ length: 8 }, (_, i) => {
            const additionalViews = i === 7 ? remainingViews : Math.floor(remainingViews * seededRandom() * 0.7);
            remainingViews -= additionalViews;
            return {
                video: `${baseEndpoint}/short_${i + 1}${isMobile ? '_mobile' : ''}.mp4`,
                views: `${((minViews + additionalViews) / 1000).toFixed(1)}k`,
                link: videos && videos[0]?.link || "https://www.youtube.com/@ai-gen-studio/shorts"
            };
        });
    };

    const fetchPlaylistVideos = async () => {
        try {

            // const response = await post('public/playlist', {});
            const response = await post('public/recent', {});
            if (response.data && response.data.data) {
                console.log(response.data.data); // Log the fetched playlist data
                return response.data.data; // Return the array of videos
            }
            console.error('No data in response');
            return [];
        } catch (err) {
            console.error('Failed to fetch playlist videos:', err);
            return [];
        }
    };

    const handleSelectedRecipe = async (course) => {
        const courseData = courseFormatters[course[0]]
        setSelectedCourse(courseData);
        setExpandCourse(true);
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    const triggerScroll = async () => {
        setTimeout(() => {
            stepperRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 400);
    }

    const triggerVote = async () => {
        setTimeout(() => {
            setExpandVoter(true);
        }, 5200);
    }

    useEffect(() => {
        let start = null;

        const easeOutExpo = (t) => {
            return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); // Exponential ease-out
        };

        const animate = (timestamp) => {
            if (!start) start = timestamp;
            const elapsed = timestamp - start;

            // Calculate progress (0 to 1)
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeOutExpo(progress);
            setPoints(Math.round(easedProgress * targetPoints));

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        const initialize = async () => {
            requestAnimationFrame(animate);

            // Fetch playlist videos
            // const playlistVideos = await fetchPlaylistVideos();
            // setPlaylistVideos(playlistVideos);

            // Adjust shorts using video links
            // setShorts(adjustShortsForScreen(playlistVideos));
            setShorts(adjustShortsForScreen());
            dispatch(aiGenAction.fetchImages());
            triggerVote();

            // Fetch images from backend
            // await fetchImagesFromBackend();
        };

        initialize();

        return () => {
            start = null;
        };
    }, []);

    <Modal expand={loading.visible} timeout={true} >
        <LoadingAnimation loadingMessage={loading.message} />
    </Modal>

    if (isAuthenticated) {
        if (!currentRoute || currentRoute.toLowerCase() === '/login' || currentRoute.toLowerCase() === '/landing' || currentRoute === '/') {
            currentRoute = '/home';
        }
        dispatch(authActions.redirectScreen(currentRoute))
        return <Navigate to={currentRoute} replace />
    }

    return (
        <div>
            <Toast></Toast>
            <Navbar />
            <VotingCard close={() => { setExpandVoter(false) }} selected={expandVoter} />
            <CourseCard course={selectedCourse} close={() => { setExpandCourse(false) }} selected={expandCourse} />
            <div className="flex w-full h-full justify-center align-middle overflow-x-hidden transition-all delay-200">
                <section className="bg-gray-200 dark:bg-gray-900 transition-all delay-200">

                    {/* {window.innerWidth < 1200 && */}
                    {/* 
                    <div className="relative">
                        <VideoComponent video={ai_gen_studio_queens} autoPlayWidth={1200}>
                            <div className="flex flex-col items-center ">
                                <h1 className="text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">This video has </h1>
                                <h2 className="text-6xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">250k Views</h2>
                                <div className="flex w-2/3 justify-center align-middle r">
                                    <button className="flex button-component mt-5 font-medium" onClick={(e) => { e.preventDefault(); console.log('cliked'); window.location.href='https://www.youtube.com/shorts/WBrEWM9puYI' }} >Watch</button>
                                </div>
                            </div>
                        </VideoComponent>
                    </div> */}

                    <div className="snap-start flex rounded-lg flex-col items-center bg-white dark:bg-black ">
                        <ShortsList shorts={shorts} />
                    </div>

                    <div className="flex w-full p-5 justify-center align-middle bg-white dark:bg-black rounded-3xl">
                        <div className="flex-col py-8 items-center align-middle justify-center " >


                            <div className="flex w-full items-center justify-center flex-row">
                                <div className="flex justify-center">
                                    <div className="flex justify-center">
                                        <div className="flex shadow-xl rounded-full aspect-[1] align-middle border-none mb-4 mx-4">
                                            <img
                                                alt="..."
                                                src={idanCover}
                                                style={{ objectFit: 'cover' }}
                                                className={`${imageLoaded ? 'opacity-100' : 'opacity-0'} flex aspect-[1] rounded-full align-middle border-none  lg:h-54 lg:w-54  h-14 w-14 transition-all duration-150 `}
                                                onLoad={handleImageLoad}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <h1 className="mb-4 text-2xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">ai gen studio</h1>

                            </div>
                            <div className="flex w-full flex-col">
                                <div className="flex flex-row items-center justify-center">
                                    <div className="flex w-10 h-10">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#22c55e">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    </div>
                                    <span className="text-green-500 dark:text-green-500 font-extrabold text-4xl count-animation">{points.toLocaleString()} viewers</span>
                                </div>

                                <p className="mb-2 my-2 text-lg font-normal text-gray-500 sm:px-16 xl:px-48 dark:text-gray-400">in the last 28 days</p>
                            </div>

                            <div className="flex flex-col w-screen px-10 my-4 mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
                                {links.map((link, index) => (
                                    <div
                                        key={index}
                                        className="inline-flex justify-center align-middle items-center "
                                    >
                                        <button
                                            className="button-component px-5 font-medium flex-row items-center"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                console.log(`Clicked: ${link.label}`);
                                                window.location.href = link.url;
                                            }}
                                        >
                                            <img
                                                className="mr-2 w-5 h-5 text-gray-400 align-middle justify-center invert"
                                                src={link.logo}
                                                alt={`${link.label} logo`}
                                            />
                                            {link.label}
                                        </button>
                                    </div>
                                ))}
                                <div className="inline-flex justify-center items-center text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800 transition-all duration-150">
                                    <button className="py-3 px-5" onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/contact') }} >contact</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="flex">
                                <ShortsList shorts={shorts} />
                    </div> */}


                    <div className="relative">
                        <VideoComponent video={'https://sawpy-assets.s3.us-east-2.amazonaws.com/videos/bike_loop.mp4'} autoPlayWidth={1200}>
                            <div className="flex flex-col items-center ">
                                <h1 className="text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Faceless channels</h1>
                                <h2 className="text-6xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Business automation</h2>
                                <div className="flex w-2/3 justify-center align-middle r">
                                    <button className="flex button-component mt-5 font-medium" onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/contact') }} >Contact</button>
                                </div>
                            </div>
                        </VideoComponent>
                    </div>

                    {/* } */}


                    <div className="flex flex-col text-center items-center lg:px-12 ">

                        <div className="flex w-screen p-5 justify-center align-middle bg-white dark:bg-black rounded-3xl">
                            <div className="flex flex-col w-full py-8 items-center align-middle justify-center " >

                                <div className="flex w-4/5 items-center justify-center flex-col">
                                    <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">create</h1>
                                    <h1 className="mb-4 text-5xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-blue-700 dark:text-blue-500">Business Automation</h1>
                                    <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">for your brand</h1>
                                </div>

                                <div className="flex content-center flex-col-reverse lg:flex-row" >

                                    {/* introduction video */}
                                    <div className="order-2 lg:order-1 inline-flex flex-col justify-center align-middle items-center my-4 px-10">
                                        <div className="flex justify-center align-middle rounded-lg border-gray-300 border-6 overflow-hidden rotate-3d">
                                            <VideoComponent video={'https://sawpy-assets.s3.us-east-2.amazonaws.com/videos/ai_gen_studio.mp4'} >
                                            </VideoComponent>
                                        </div>
                                    </div>


                                </div>

                                <div className="flex flex-col w-full my-4 mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">

                                    <div className="inline-flex justify-center items-center text-base font-bold text-center text-white rounded-lg  dark:bg-blue-500 bg-blue-700 dark:hover:bg-blue-700 dark:focus:ring-gray-800 transition-all duration-150">
                                        <button className="py-3 px-5" onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/contact') }} >Contact</button>
                                    </div>

                                    <div className="inline-flex justify-center items-center text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800 transition-all duration-150">
                                        <button className="py-3 px-5" onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/courses') }} >Courses</button>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* introduction profile */}
                        <div className="inline-flex flex-col justify-center align-middle items-center my-4 px-10">
                            <div className="py-5 flex justify-center align-middle">

                                <div className="flex flex-col justify-center align-middle items-center mb-10">
                                    <div className="w-full px-4 lg:order-2 flex justify-center">
                                    </div>
                                </div>


                            </div>
                            <div className="flex flex-row-reverse justify-center  text-center content-center align-text-bottom">
                                <h4 className="text-xl font-semibold leading-normal mb-2 text-blueGray-700 self-center w-1/2">Create faceless channels and get passive income</h4>
                                <h3 className="text-7xl font-semibold leading-normal mb-2 text-blueGray-700 mx-2 hover:animate-pulse ease-in-out">AI</h3>
                            </div>


                            <div className="inline-flex justify-center w-full mx-10 items-center text-base font-bold text-center text-white rounded-lg  dark:bg-blue-500 bg-blue-700 dark:hover:bg-blue-700 dark:focus:ring-gray-800 transition-all duration-150">
                                <button className="py-3 px-5" onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/contact') }} >Set Up A meeting</button>
                            </div>

                            {/* <div className="inline-flex justify-center align-middle items-center ">

                                <button className="button-component px-10 my-5 font-medium" onClick={(e) => { e.preventDefault(); navigate('/contact') }} >Contact</button>
                            </div> */}
                        </div>

                        {/* come and learn  */}
                        {/* <div className="flex w-full h-full justify-center align-middle px-2">
                            <div className="flex flex-col lg:pb-10 rounded-lg">
                                <p className="my-4 text-4xl font-bold text-center text-gray-900 dark:text-gray-50">בואו ללמוד</p>
                                <p className="my-4 text-lg text-center font-normal  lg:text-xl sm:px-16 text-gray-800 dark:text-gray-100">תלמדו כיצד להפוך את המחשב לעובד שלכם</p>
                                <div className="inline-flex justify-center align-middle items-center ">
                                    <button className="button-component px-5 font-medium" onClick={(e) => { e.preventDefault(); navigate('/signup') }} >להרשמה</button>
                                </div>
                            </div>
                        </div> */}


                        <div className="snap-start flex h-full my-6 rounded-lg flex-col items-center ">

                            <div className="flex my-4">
                                <ReviewList reviews={reviews} />
                            </div>



                        </div>




                        {/* <div className="snap-start flex h-full w-full py-10 rounded-xl dark:bg-black bg-gray-50 flex-col items-center">
                            <div className="inline-flex lg:grid lg:grid-cols-2 flex-col items-center my-4 px-7 w-full align-middle ">
                                {courseFormatters.map((formatter, index) => (
                                    <div key={index} className="flex m-3 hover:scale-110 transition-all ease-in-out duration-400 ">
                                        <Card adapter={new CardFormatter(index, formatter.title, formatter.subtitle, handleSelectedRecipe, '', formatter.logo, false)} />
                                    </div>
                                ))}
                            </div>
                        </div> */}

                        <div className="snap-start flex h-full w-full py-10 rounded-xl dark:bg-black bg-gray-50 flex-col items-center">
                            <OverlappingCards courses={courseFormatters} trigger={handleSelectedRecipe} />
                        </div>
                        {/* <ImageGrid adapter={new ImageGridFormatter([new ImageGridElement(1,'midjounery',midjourney_1)])}/> */}
                        {/* <div className='landing-container  items-center dark:bg-black'>
                            <div className="flex w-full justify-center items-center align-middle lg:flex-row flex-col">
                                <div className='flex text-4xl font-bold py-2 text-gray-700 dark:text-gray-50 my-2'>Make custom images from yours</div>
                                <div className="landing-container py-10">
                                    <ImageGrid adapter={new ImageGridFormatter(imageElements, (e) => { console.log(e) }, false, true)} />
                                </div>
                            </div>
                        </div> */}


                        <div className="p-16 bg-white dark:bg-black w-full h-full">

                        </div>



                        {/* <div className="snap-start flex h-full my-2 rounded-lg flex-col ">
                            <div className="flex justify-between flex-col lg:flex-row " >

                                <section className="mb-32 text-gray-800 text-center">
                                    <div className="grid md:grid-cols-3 lg:gap-x-12">
                                        <div className="mb-12 md:mb-0">
                                            <div className="p-4 bg-blue-600 rounded-lg shadow-lg inline-block mb-6">
                                                <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path fill="currentColor"
                                                        d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z">
                                                    </path>
                                                </svg>
                                            </div>
                                            <h5 className="text-lg font-bold mb-4">about the buisness</h5>
                                            <p>We provide a simple, easy-to-use, and reliable recipe generator. Simply input your ingredients, and our site will provide you with a selection of recipes to choose from. You can even combine multiple recipes into one!</p>

                                        </div>

                                        <div className="mb-12 md:mb-0">
                                            <div className="p-4 bg-blue-600 rounded-lg shadow-lg inline-block mb-6">
                                                <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path fill="currentColor"
                                                        d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z">
                                                    </path>
                                                </svg>
                                            </div>
                                            <h5 className="text-lg font-bold mb-4">Features</h5>
                                            Easy-to-use recipe generator,
                                            Selection of recipes based on provided ingredients,
                                            Option to combine multiple recipes into one
                                        </div>

                                        <div className="mb-12 md:mb-0">
                                            <div className="p-4 bg-blue-600 rounded-lg shadow-lg inline-block mb-6">
                                                <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                                    <path fill="currentColor"
                                                        d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z">
                                                    </path>
                                                </svg>
                                            </div>
                                            <h5 className="text-lg font-bold mb-4">Extremely fast</h5>
                                            <p className="text-gray-500">
                                                Enim cupiditate, minus nulla dolor cumque iure eveniet facere ullam beatae hic
                                                voluptatibus dolores exercitationem? Facilis debitis aspernatur amet nisi?
                                            </p>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div> */}
                        {/* <img src={aiLogos} alt="ai_tools"></img> */}

                        {/* <div className=" flex w-full flex-col bg-gray-300 dark:bg-black rounded-2xl justify-center content-between py-10">
                            <div className="flex w-screen lg:max-w-screen-2xl flex-col mx-auto py-2 items-center">
                                <h2 className="text-3xl text-black dark:text-white font-bold">Our Partners</h2>
                                <div className="grid grid-flow-col gap-x-12 w-screen max-h-0.5 pb-10 px-8 max-w-xl m-2 aspect-[1] items-center align-middle my-24">
                                    {partnerImages.map((image, index) => (
                                        <div key={index}>
                                            <img className="block lg:hidden dark:invert" src={image.src} alt={image.alt} />
                                            <img className="hidden lg:block dark:invert" src={image.src} alt={image.alt} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div> */}

                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
}

export default Landing;